import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { UploadService } from '../../services/upload/upload.service';
import { DmsFile } from '../../modal/upload/model/upload.model';

@Component({
  selector: 'app-idex-utrr',
  standalone: false,
  templateUrl: './idex-utrr.component.html',
  styleUrl: './idex-utrr.component.scss'
})
export class IdexUtrrComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() stepCompleted = new EventEmitter<void>();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() id: any;
  @Input() data: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  aip: FormGroup;
  apiUrl = environment.APIUrl;
  selectedProduct: any
  payload: any;
  uploadedFiles: any[] = [];
  aipId: any;
  aipData: any;
  uploadedDocs: any;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  commentForm: FormGroup;
  editData: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @ViewChild('table') table: Table;
  uploadedFileName: string = '';
  file: File;
  vendors: any[] = [];
  resId: any;
  shortlistedvendor: any;
  selectedFinalOfferFile: File | null = null;
  finalOfferFilePath: string | null = null;
  @Input() schemeType: any;
  selectedFinalOfferFiles: File[] = [];
  filesList: any;
  private subscriptions = new Subscription();
  userID: any;
  allDmsFiles:any[]=[];
  constructor(
    private fb: FormBuilder,
    // private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private uploadService: UploadService,
    private route: ActivatedRoute
  ) { 
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.commentForm = this.fb.group({
      comment: [''],
    });

    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      };
    });
    this.getTrials()
    if (this.schemeType == 'idex') {
      this.getVendors()
    }
    //         if (this.isEditable) {
    //   this.commentForm.enable();
    // } else {
    //   this.commentForm.disable();
    // }
    console.log("scheme" , this.schemeType)
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.isEditorDisabled=true;
       if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.edit();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      // this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  patchFormValues(data: any) {
    this.aip.patchValue({
      file_name: data.file_name,
      file_number: data.file_number
    });
  }

  onUpload(event: any) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'File attached successfully'
    });
  }

  // getTrials() {
  //   this.api.getAPI(`/idex/user/trials/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`).subscribe({
  //     next: (res: any) => {
  //       this.resId = res[0].id
  //       this.editData = res[0]
  //       this.commentForm.patchValue({
  //         comment: res[0].comment
  //       });
  //       // this.vendors = res[0].trial_vendor
  //     },
  //     error: (err) => { }
  //   })
  // }
  getTrials() {
    let url;
    if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/user/trials/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
    } else if (this.schemeType == 'idex') {
      url = `/idex/user/trials/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/dvpt/trial/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
    }else if (this.schemeType == 'rev') {
      url = `/revenue/user/trials/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
    }
    const sub = this.api
      .getAPI(url)
      .subscribe((res: any) => {
        console.log('this is trials data', res);
        const dmsFiles: DmsFile[] = res.dms_files;
        this.allDmsFiles = dmsFiles;
        this.vendors = [];
        if (res && res.trial_vendor || res && res.trialmake_da) {
          this.resId = res.id;
          this.editData = res;
          // Patch the comment into the form
          this.commentForm.patchValue({
            comment: res?.comment || res[0]?.comment || ''
          });
          if (this.schemeType == 'idex') {
            console.log(res)
            // Map trial_vendor array to vendors
            res.trial_vendor.forEach((tv: any) => {
              this.vendors.push({
                id: res.id,                              // user_trial id (common)
                trialVendorId: tv.id,                    // trial_vendor id
                vendor: tv.vendor?.id || null,           // for dropdown ngModel
                vendorName: tv.vendor?.name || '',       // fallback display
                file: tv.document,               // file path
                uploadedFile: null                       // for new upload
              });
            });
          }
        else  if (this.schemeType == 'makeI') {
            this.shortlistedvendor = res.trialmake_da[0]?.vendor || res[0].vendor
            this.finalOfferFilePath = res.signed_documents;
            //  sessionStorage.setItem('final_vendor', res[0].vendor.vendor_id);
          }
        } else if(this.schemeType == 'makeII' || this.schemeType=='makeIII') {
            console.log("RES" , res[0])
            this.shortlistedvendor =  res[0].vendor
            this.finalOfferFilePath = res[0].signed_documents;
            this.resId = res[0].id;
            this.commentForm.patchValue({
            comment: res[0].comment || ''
          });
             sessionStorage.setItem('final_vendor', res[0].vendor.vendor_id);

          } else if (this.schemeType == 'tdf' || this.schemeType == 'rev' ){
           this.shortlistedvendor = res[0].vendor
          this.finalOfferFilePath = res[0].file || res[0].signed_documents

           this.resId = res[0].id;
            this.commentForm.patchValue({
            comment: res[0].comment || ''
          });
        }
      });

    this.subscriptions.add(sub);
  }



  getVendors() {
    const sub = this.api.getAPI(`/idex/user/trials/vendors/?user_trial__proposal_step=${this.step.id}&user_trial__proposal_step__proposal=${this.payload.proposal_id}`).subscribe({
      next: (res: any) => {
        this.vendors = res
      },
      error: (err) => { }
    })
    this.subscriptions.add(sub);
  }





  edit() {
    this.commentForm.enable();
    this.isEditorDisabled = false;
  }
  // onSubmit() {
  //    const formData = new FormData();
  //  for (let file of this.uploadedFiles) {
  //     // this.uploadedFiles.push(file);
  //     formData.append('signed_documents', file);
  //   }

  //   formData.append('proposal_step', this.step.id);
  //   formData.append('comment', this.commentForm.get('comment')?.value);
  //   if (this.aipId) {
  //     this.api.putAPI(`/idex/user/trials/${this.aipId}/`, formData).subscribe(res => {
  //       console.log(res);
  //       // this.uploadedDocs.push(res)
  //       this.messageService.add({ severity: 'success', summary: 'Success', detail: 'File uploaded successfully' });
  //       this.getTrials()
  //     });
  //   } else {
  //     this.api.postAPI(`/idex/user/trials/`, formData).subscribe(res => {
  //       console.log(res);
  //       this.getTrials()
  //       this.messageService.add({ severity: 'success', summary: 'Success', detail: 'File uploaded successfully' });
  //     });
  //   }
  //   this.fileUpload.clear();

  // }
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.commentForm.get('comment')?.value },

      ]
    };

    this.generatePDFEmitter.emit(payload);
  }
  clearUpload() {
    this.uploadedFileName = null;
    this.selectedFinalOfferFile = null;
    this.fileUpload.clear();
  }

  addRow() {
    const newRow = {
      id: 'new_' + Date.now(), // Unique temp ID
      vendor: null,
      file: null,
      isNew: true // flag to identify this as new row
    };
    this.vendors = [...this.vendors, newRow];
    if (this.schemeType == 'idex') {
      this.updateWinners();
    }
  }

  onRowEditInit(rowData: any) {
    console.log(rowData)
    // Optional: Store a copy of original row if needed
    rowData.originalData = { ...rowData };
  }

 onRowEditSave(rowData: any) {
  const formData = new FormData();

  const vendorId = rowData.vendor;
  formData.append('proposal_step', this.step.id);
  formData.append('user_trial', this.resId);
  formData.append('vendor_id', vendorId);

  if (rowData.uploadedFile) {
    formData.append('document', rowData.uploadedFile);
  }

  // Check if vendor already exists in this.vendors (i.e., update case)
  const existingVendor = this.vendors.find(v => v.vendor === vendorId);

  let request$;
  if (existingVendor && existingVendor.trialVendorId) {
    // PUT = update existing trial_vendor
    request$ = this.api.putAPI(`/idex/user/trials/vendors/${existingVendor.trialVendorId}/`, formData);
  } else {
    // POST = new trial_vendor
    request$ = this.api.postAPI(`/idex/user/trials/vendors/`, formData);
  }

  const sub = request$.subscribe((res: any) => {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: res.message || 'Vendor updated successfully'
    });

    this.table.cancelRowEdit(rowData);
    this.getTrials(); // Refresh table with latest data
  });

  this.subscriptions.add(sub);
}


  onRowEditCancel(rowData: any, index: number) {
    // Revert to original data
    if (rowData.originalData) {
      this.vendors[index] = { ...rowData.originalData };
    }
  }
  onFileUpload(event: any, rowData: any): void {
    const file = event.target.files[0];
    const maxSizeMB = 200;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file.size > maxSizeBytes) {
      this.messageService.add({
        severity: 'error',
        summary: 'File Too Large',
        detail: `Maximum allowed size is ${maxSizeMB}MB.`,
      });
      event.target.value = ''; // Reset file input
      return;
    }
    if (file) {
      rowData.uploadedFile = file;
      rowData.uploadedFileName = file.name;
    }
  }
  // onSubmit() {
  //   const justification = this.commentForm.get('comment')?.value;

  //   const sub = this.api.putAPI(`/revenue/technical-negotiation/${this.resId}/`, {
  //     justification: justification,
  //   }).subscribe({
  //     next: () => {
  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Success',
  //         detail: `Justification submitted`
  //       });
  //     },
  //     error: () => {
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Error',
  //         detail: `Failed to submit justification`
  //       });
  //     }
  //   });
  //   this.subscriptions.add(sub);
  // }
  onUploadforMake(event: any): void {
    const file = event.files?.[0];
    this.file = file;
    if (!file) return;
    this.selectedFinalOfferFile = file;
  }
  onJustificationSubmit() {
    const justification = this.commentForm.get('comment')?.value;
    let url;
    if (this.resId) {
      if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
        url = `/make1/user/trials/${this.resId}/`
      } else if (this.schemeType == 'idex') {
        url = `/idex/user/trials/${this.resId}/`
      } else if (this.schemeType == 'tdf') {
        url = `/tdf/dvpt/trial/${this.resId}/`
      }else{
        url = `/revenue/user/trials/${this.resId}/`
        
      }
      let formData = new FormData();

      formData.append('proposal_step', this.id);
      formData.append('comment', justification);

      if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
        if(this.file)
        formData.append('signed_documents', this.file)
      }else if (this.schemeType == 'tdf') {
         if(this.file)
        formData.append('file', this.file)
      }else if(this.schemeType == 'rev'){
         if (this.selectedFinalOfferFiles.length > 0) {
          this.selectedFinalOfferFiles.forEach((file) => {
            formData.append('trials_files', file);
          });
        }
      }
//  if (this.selectedFinalOfferFiles.length > 0) {
//           this.selectedFinalOfferFiles.forEach((file) => {
//             formData.append('trials_files', file);
//           });
//         }

      const sub = this.api.putAPI(url, formData).subscribe({
        next: () => {
          this.fileUpload.clear();
          // this.finalOfferFilePath = null;
          this.selectedFinalOfferFile = null
          this.getTrials();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Data submitted`
          });
        },
        error: () => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: `Failed to submit justification`
          // });
        }
      });
      this.subscriptions.add(sub);
    }else if(!this.resId && (this.schemeType == 'tdf')){
       url = `/tdf/dvpt/trial/`
       let formData = new FormData();

      formData.append('proposal_step', this.id);
      formData.append('comment', justification);
       if(this.file){
         formData.append('file', this.file);
       }

         const sub = this.api.postAPI(url, formData).subscribe({
        next: () => {
          this.fileUpload?.clear();
          // this.finalOfferFilePath = null;
          this.selectedFinalOfferFile = null
          this.selectedFinalOfferFiles = []
          this.getTrials();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Data submitted`
          });
        },
        error: () => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: `Failed to submit justification`
          // });
        }
      });
      this.subscriptions.add(sub);

      
    }else{
      if(this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII'){
        url = `/make1/user/trials/`
      }else{
        url = `/revenue/user/trials/`
      }
      
      let formData = new FormData();

      formData.append('proposal_step', this.id);
      formData.append('comment', justification);
       if(this.file){
         formData.append('file', this.file);
       }

         const sub = this.api.postAPI(url, formData).subscribe({
        next: () => {
          // this.fileUpload.clear();
          // this.finalOfferFilePath = null;
          this.selectedFinalOfferFile = null
          this.getTrials();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Data submitted`
          });
        },
        error: () => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: `Failed to submit justification`
          // });
        }
      });
      this.subscriptions.add(sub);
    }
  }
  totalRecords = 0;
  updateWinners(event: { page: number; search?: string } = { page: 1 }) {
    const url = this.schemeType == 'tdf' ? `/idex/finalize/winner/?evaluation__proposal_step__proposal=${this.payload.proposal_id}&evaluation__proposal_step=${this.step.id}` : `/idex/finalize/winner/?evaluation__proposal_step__proposal=${this.payload.proposal_id}&evaluation__proposal_step=${this.step.id}`
    const sub = this.api.getAPI(url).subscribe((res: any) => {
      this.data = res.data;
      this.totalRecords = res.data.length
    });
    this.subscriptions.add(sub);
  }
    onUploadRev(event: any): void {
    const files = event.files;
    if (!files?.length) return;
    // Append new files to the array (avoid duplicates if needed)
    this.selectedFinalOfferFiles.push(...files);
  }
  removeFile(index: number): void {
    this.selectedFinalOfferFiles.splice(index, 1);
  }

  openFileInNewTab(file: File): void {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
    // Optional: revokeObjectURL after some time for memory cleanup
    setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
  }
}
